module.exports = __webpack_public_path__ + "static/media/IMG_0052.ee5677f3.jpg";